import { MultiSelect } from '@mantine/core'
import { useEffect, useState } from 'react'
import { CategoryDto, fetchCategories } from '../../../data/location.service'

interface AdvertiserRestrictionsStepProps {
  restrictedCategories: number[]
  setRestrictedCategories: (categories: number[]) => void
}
function AdvertiserRestrictionsStep(props: AdvertiserRestrictionsStepProps) {
  const { restrictedCategories, setRestrictedCategories } = props
  const [categories, setCategories] = useState<CategoryDto[]>([])

  useEffect(() => {
    const loadCategories = async () => {
      try {
        const fetchedCategories = await fetchCategories()
        setCategories(fetchedCategories)
      } catch (error) {
        console.error('Error fetching categories:', error)
      }
    }

    loadCategories()
  }, [])

  const handleChange = (categories: string[]) => {
    setRestrictedCategories(categories.map((c) => parseInt(c)))
  }
  return (
    <MultiSelect
      w='80%'
      maw={600}
      description='Optional'
      placeholder='Select all that apply'
      data={categories.map((c) => ({ label: c.name, value: c.id.toString() }))}
      value={restrictedCategories.map((c) => c.toString())}
      onChange={handleChange}
      searchable
      clearable
    />
  )
}

export default AdvertiserRestrictionsStep
